// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_webpack@5.105.2/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lVnnPnXEK_zLWf {
  z-index: 2;
  flex-direction: column;
  display: flex;
}

.lVnnPnXEK_zLWf .pxKCKCdZxzotfu {
  margin-left: var(--ds-space-0, 0);
  flex-direction: row;
  align-items: center;
  display: flex;
}

.lVnnPnXEK_zLWf .pxKCKCdZxzotfu .U9IgWRt7kQPayY, .lVnnPnXEK_zLWf .pxKCKCdZxzotfu .SVDYMNoDsJaS1J {
  width: var(--ds-space-300, 24px);
  min-width: 0;
  height: var(--ds-space-300, 24px);
  min-height: 0;
  padding: var(--ds-space-050, 4px);
  color: var(--ds-text-subtlest, #626f86);
  cursor: pointer;
}

.lVnnPnXEK_zLWf .pxKCKCdZxzotfu .U9IgWRt7kQPayY:hover, .lVnnPnXEK_zLWf .pxKCKCdZxzotfu .SVDYMNoDsJaS1J:hover, .lVnnPnXEK_zLWf .pxKCKCdZxzotfu .U9IgWRt7kQPayY:focus, .lVnnPnXEK_zLWf .pxKCKCdZxzotfu .SVDYMNoDsJaS1J:focus, .lVnnPnXEK_zLWf .pxKCKCdZxzotfu .U9IgWRt7kQPayY.JHZ_TlUW3Az5Sw, .lVnnPnXEK_zLWf .pxKCKCdZxzotfu .SVDYMNoDsJaS1J.JHZ_TlUW3Az5Sw {
  color: var(--ds-text, #172b4d);
}

.lVnnPnXEK_zLWf .pxKCKCdZxzotfu .SVDYMNoDsJaS1J {
  transform: rotate(180deg);
}

.lVnnPnXEK_zLWf .pxKCKCdZxzotfu .zyt2bMoYPQYwmB {
  column-gap: var(--ds-space-0, 0);
  display: flex;
}

.lVnnPnXEK_zLWf.VMACpQ9RZtuvhv {
  bottom: var(--ds-space-300, 24px);
  left: var(--ds-space-300, 24px);
  width: 300px;
  padding: var(--ds-space-200, 16px);
  border-radius: var(--ds-radius-small, 4px);
  background-color: var(--ds-surface, #fff);
  box-shadow: var(--ds-shadow-overlay, 0 8px 12px #091e4226);
  animation: .2s ease-in-out A5LeaGQpjNxjVm;
  position: absolute;
}

.lVnnPnXEK_zLWf.VMACpQ9RZtuvhv .R34vw0YIAGqdR_ {
  justify-content: space-between;
  align-items: center;
  width: 100%;
  display: flex;
}

.lVnnPnXEK_zLWf.VMACpQ9RZtuvhv .R34vw0YIAGqdR_ .a8LbdyPawXRehw {
  align-items: flex-start;
  gap: var(--ds-space-050, 4px);
  flex-direction: column;
  align-self: stretch;
  display: flex;
}

.lVnnPnXEK_zLWf.VMACpQ9RZtuvhv .R34vw0YIAGqdR_ .a8LbdyPawXRehw .O9Z4u0UFuN4yt0 {
  font-weight: var(--ds-font-weight-bold, 700);
}

.lVnnPnXEK_zLWf.VMACpQ9RZtuvhv .R34vw0YIAGqdR_ .iC94I8oc4PRZYw {
  min-width: var(--ds-space-300, 24px);
  min-height: var(--ds-space-300, 24px);
  padding: var(--ds-space-025, 2px);
  background-color: var(--ds-surface, #fff);
  align-self: flex-start;
}

.lVnnPnXEK_zLWf.VMACpQ9RZtuvhv .R34vw0YIAGqdR_ .iC94I8oc4PRZYw:hover, .lVnnPnXEK_zLWf.VMACpQ9RZtuvhv .R34vw0YIAGqdR_ .iC94I8oc4PRZYw:focus, .lVnnPnXEK_zLWf.VMACpQ9RZtuvhv .R34vw0YIAGqdR_ .iC94I8oc4PRZYw:active {
  background-color: var(--ds-surface-hovered, #f1f2f4);
}

.lVnnPnXEK_zLWf.VMACpQ9RZtuvhv .pxKCKCdZxzotfu {
  margin-left: var(--ds-space-100, 8px);
  flex-direction: column;
  align-items: flex-start;
}

.lVnnPnXEK_zLWf.VMACpQ9RZtuvhv .pxKCKCdZxzotfu .U9IgWRt7kQPayY, .lVnnPnXEK_zLWf.VMACpQ9RZtuvhv .pxKCKCdZxzotfu .SVDYMNoDsJaS1J {
  width: var(--ds-space-300, 24px);
  height: var(--ds-space-300, 24px);
  padding: var(--ds-space-050, 4px);
}

.lVnnPnXEK_zLWf.VMACpQ9RZtuvhv .pxKCKCdZxzotfu .zyt2bMoYPQYwmB {
  margin: var(--ds-space-050, 4px) var(--ds-space-0, 0);
  column-gap: var(--ds-space-050, 4px);
}

.lVnnPnXEK_zLWf.VMACpQ9RZtuvhv .pxKCKCdZxzotfu .p6thGTOu_ohDvs {
  margin-top: var(--ds-space-100, 8px);
}

@media only screen and (width <= 600px) {
  .lVnnPnXEK_zLWf.VMACpQ9RZtuvhv {
    bottom: var(--ds-space-0, 0);
    left: var(--ds-space-0, 0);
  }
}

.mv6JXWzYIUZ_49 {
  color: var(--ds-text-subtle, #44546f);
  flex-direction: column;
  display: flex;
}

.UJVdP__aVvxTl7 {
  margin: var(--ds-space-0, 0);
  padding-left: var(--ds-space-300, 24px);
  color: var(--ds-text-subtlest, #626f86);
  font-size: 12px;
  line-height: 16px;
}

@keyframes A5LeaGQpjNxjVm {
  from {
    transform: translateX(-120px);
  }

  to {
    transform: translateX(0);
  }
}
`, ""]);
// Exports
export var feedbackCollectorContainer = `lVnnPnXEK_zLWf`;
export var feedbackButtonsContainer = `pxKCKCdZxzotfu`;
export var positiveFeedbackButton = `U9IgWRt7kQPayY`;
export var negativeFeedbackButton = `SVDYMNoDsJaS1J`;
export var selected = `JHZ_TlUW3Az5Sw`;
export var thumbButtonGroup = `zyt2bMoYPQYwmB`;
export var flagTreatment = `VMACpQ9RZtuvhv`;
export var slideFromLeft = `A5LeaGQpjNxjVm`;
export var titleAndCloseButton = `R34vw0YIAGqdR_`;
export var titleSection = `a8LbdyPawXRehw`;
export var mainTitle = `O9Z4u0UFuN4yt0`;
export var closeButton = `iC94I8oc4PRZYw`;
export var joinSessionLink = `p6thGTOu_ohDvs`;
export var sessionDataCheckboxContainer = `mv6JXWzYIUZ_49`;
export var sessionDataCheckboxDescription = `UJVdP__aVvxTl7`;
export default ___CSS_LOADER_EXPORT___;
